// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_kKj19","name":"name_fjEct","g-prod-share":"g-prod-share","activity-tag":"activity-tag_-asor","product-tag":"product-tag_qPamw"};